const styles = {
  buttonTransparent: {
    background: 'transparent',
    color: '#417df4',
    padding: '0px',
  },
};

export default styles;
